import React from 'react'
import OnlinePay from '../../../assets/icons/pay-online.png'

export const OnlinePayIcon = () => <img src={OnlinePay} alt="Ícone pagamento online" />
